<ng-container *ngIf="transactionalDataState$ | async as state">
    <div class="timeRecord-container mat-elevation-z8">
        <div class="table-header">
            <mat-form-field style="width: 20%" subscriptSizing="dynamic">
                <mat-label>{{ "app.external-data.daterange.label" | translate }}</mat-label>
                <mat-date-range-input [formGroup]="datefilterFormGroup" [rangePicker]="picker">
                    <input matStartDate formControlName="start">
                    <input matEndDate formControlName="end">
                </mat-date-range-input>
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-date-range-picker #picker></mat-date-range-picker>
            </mat-form-field>
            <mat-form-field subscriptSizing="dynamic">
                <input matInput #filter (keyup)="applyFilter($event.target.value)" placeholder="Filter">
                <button mat-icon-button matSuffix aria-label="clear" *ngIf="filter.value"
                        (click)="filter.value=''; applyFilter('');">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>
        </div>
        <mat-progress-bar color="accent" [style.visibility]="state.isLoading ? 'visible' : 'hidden'" mode="indeterminate"></mat-progress-bar>
        <div class="table-container">
            <table mat-table matSort [dataSource]="dataSource">

                <ng-container matColumnDef="articleNr">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "app.model.timeRecord.articleNr.label" | translate}}</th>
                    <td mat-cell *matCellDef="let element"> {{element.articleNr}} </td>
                </ng-container>

                <ng-container matColumnDef="date">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "app.model.timeRecord.date.label" | translate}}</th>
                    <td mat-cell *matCellDef="let element">
                        {{element.date | date: 'dd.MM.yyyy'}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="minutes">
                    <th mat-header-cell *matHeaderCellDef arrowPosition="before" mat-sort-header>{{ "app.model.timeRecord.minutes.label" | translate}}</th>
                    <td mat-cell *matCellDef="let element">
                        {{element.minutes}}
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="state.timeRecordColumns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: state.timeRecordColumns;"></tr>

            </table>
            <mat-paginator showFirstLastButtons [pageSizeOptions]="[20, 50]"></mat-paginator>
        </div>
    </div>
</ng-container>
